import React from "react";
import { SwitchDictionary, SwitchProps } from "./Switch.types";
import { getClassName } from "../../helpers/common.helpers";
import ButtonComponent from "../Button/ButtonComponent";
import "./Switch.scss";

const Switch = ({ switchData, activeTab, switchWrapperClassName = "", tabClassName = "", onTabClick }: SwitchProps) => {

    return (
        <div className={getClassName("switch-wrapper", switchWrapperClassName)} >
            {switchData.map(({ tabName }: SwitchDictionary, index) => {
                return <ButtonComponent key={index} variant={activeTab === index ? "outline-primary" : "outline-secondary"} buttonClassName={`switch-wrapper__tab-container ${tabClassName}`} onClick={() => onTabClick(index)}>{tabName}</ButtonComponent>
            })}
        </div>
    )
}

export default Switch; 
